function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaisedBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2780",
    d: "M3 3h18v18H3z",
    style: {
      fill: "#fff",
      stroke: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2781",
    d: "M5 5h14v14H5z",
    style: {
      fill: "#a75712"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedBed);
export default __webpack_public_path__ + "static/media/raised-bed.af1290f8c94a7cb254ed0ab897fd441c.svg";
export { ForwardRef as ReactComponent };